import { useQuery } from '@tanstack/react-query';
import { getAnalytics, type AnalyticsResponse, type AnalyticsQueryOptions } from '../api';

/**
 * Hook to fetch analytics data for reporting dashboard
 * @param options - Optional filters (date range, trend days)
 * @param enabled - Whether to fetch the analytics (default: true)
 */
export function useAnalytics(options?: AnalyticsQueryOptions, enabled = true) {
  return useQuery({
    queryKey: ['analytics', options?.startDate, options?.endDate, options?.trendDays],
    queryFn: (): Promise<AnalyticsResponse> => getAnalytics(options),
    enabled,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}
